// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__1tjEF","total":"Cart_total__1acFI","actions":"Cart_actions__3TR92","button--alt":"Cart_button--alt__1548p","button":"Cart_button__38pU4"};